export default {
  language: 'Idioma',
  common: {
    cancel: 'Cancelar',
    fieldEmpty: 'Este campo no puede estar vacío.',
    loading: 'Cargando...',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    rpassword: 'Repite la contraseña',
    mobile: 'Número de teléfono móvil',
    email: 'Correo electrónico',
    login: 'Iniciar sesión',
    signup: 'Inscribirse',
    back: 'Atrás',
    next: 'Próximo',
    submit: 'Enviar',
    continue: 'Continuar',
    close: 'Cerrar',
    leg: 'Pierna',
    getFee: 'GET tarifa',
    get: 'GET',
    serviceFee: 'Tarifa de servicio',
    militaryClearance: 'Liquidación militar',
    endDateMust: 'La fecha de finalización debe ser posterior a la fecha de inicio.',
    maxDurationCharter: 'La duración máxima para la reserva de chárter es {time}.',
    invalidDateRange: 'Intervalo de fechas no válido.',
    fieldRequired: 'El campo {field} es obligatorio.',
    invalidEmail: 'El campo de correo electrónico debe ser un correo electrónico válido.'
  },
  searchForm: {
    bookARide: 'Reserve un viaje',
    bookACharter: 'Reserve un charter por hora',
    requestARide: 'Solicita un viaje ahora',
    bookCharter: 'Reserva un servicio de chárter',
    enterPickup: 'Ingrese su lugar de recogida:',
    extraStop: 'Parada adicional:',
    enterDropoff: 'Ingrese su ubicación de entrega:',
    whenDoYou: 'Cuándo necesitas un viaje?',
    untilWhen: 'Hasta cuándo lo necesitas?',
    getAQuote: 'Consigue una cotización',
    gettingQuote: 'Obteniendo cotización ...',
    editCancel: 'Editar/Cancelar su viaje',
    editRsvp: 'Editar Reserva',
    trackVehicle: 'Seguimiento de su vehículo',
    trackRsvp: 'Reserva de seguimiento',
    or: 'o',
    haveCorporate: 'Tienes una cuenta corporativa?',
    loginSignup: 'Iniciar sesión/Registrarse aquí',
    not: 'No',
    signout: 'Desconectar',
    youAreLogged: 'Ha iniciado sesión como cuenta personal.',
    locationPlaceholder: 'p.ej. Aeropuerto, hogar, etc.',
    startDateGreater: 'La fecha de inicio debe ser superior a {WebTimeBuffer} minutos desde la hora actual.',
    manualPickup: 'La entrada de texto de la ubicación de recogida manual no es lo suficientemente precisa',
    unablePinpointPickup: 'No se puede identificar el lugar de recogida deseado.',
    manualLocation: 'La entrada de texto de ubicación manual no es lo suficientemente precisa',
    unablePinpointExtra: 'No se puede identificar la ubicación de la parada adicional deseada.',
    manualDropoff: 'La entrada de texto de ubicación de entrega manual no es lo suficientemente precisa',
    unablePinpointDropoff: 'No se puede precisar la ubicación de entrega deseada.',
    noAvailableService: 'Ningún tipo de servicio disponible',
    sorryService: 'Perdón! Nuestros servicios aún no están disponibles en esta área.',
    youCanAdd: 'Puede agregar una parada adicional.',
    airports: 'Aeropuertos',
    themeParks: 'Parques tematicos',
    ports: 'Puertos',
    hotel: 'Hoteles',
    universities: 'Universidades',
    setMap: 'Establecer en el mapa',
    map: 'Mapa',
    setLocation: 'Escoger localización',
    sorry: 'Perdón',
    coudntLocate: 'No pudimos localizar',
    pleaseFillForm: 'Por favor complete este formulario para crear una cuenta',
    recommendedSize: 'Tamaño recomendado:',
    corporateName: 'Nombre corporativo',
    website: 'Sitio web',
    billingInfo: 'Datos de facturación',
    creditCard: 'Tarjeta de crédito #',
    cardName: 'Nombre del titular de la tarjeta',
    exp: 'Vencimiento',
    cvv: 'cvv',
    addr: 'Dirección',
    addr1: 'Dirección 1',
    addr2: 'Dirección 2',
    city: 'Ciudad',
    state: 'Expresar',
    nonUs: 'Non US',
    zip: 'Código postal',
    country: 'País',
    reviewDetails: 'Revise sus datos',
    submitting: 'Sumisión. Espere por favor...',
    thankYouSignup: 'Gracias por registrarte!',
    yourCorporate: 'Su perfil corporativo está esperando la aprobación del administrador. Recibirá un aviso una vez que su cuenta haya sido aprobada.',
    ok: 'OK',
    pleaseUpload: 'Sube una imagen.',
    spaceNotAllowed: 'No se permite espacio',
    validEmail: 'Introduzca una dirección de correo electrónico válida.',
    passwordNotMatch: 'La contraseña y la contraseña de repetición no coinciden.',
    uploadImgFail: 'Error al cargar la imagen. Inténtalo de nuevo.',
    serviceNA: 'Servicios no disponibles'
  },
  serviceSelect: {
    changeSelect: 'Ver más opciones de servicio',
    future: 'En el futuro',
    rightNow: 'Ahora mismo',
    selectAsap: 'Seleccione esta opción si desea que lo recojan lo antes posible.',
    dateAsapLyft: 'Las paradas adicionales no están disponibles para viajes urgentes y se eliminarán automáticamente.',
    pickAsap: 'Recógeme lo antes posible',
    selectStartDate: 'Seleccione una fecha de inicio:',
    selectEndDate: 'Seleccione una fecha de finalización:',
    selectPickupDate: 'Seleccione una fecha de recogida:',
    flightArrival: 'Fecha de llegada del vuelo',
    flightDeparture: 'Fecha de salida del vuelo',
    selectStartTime: 'Seleccione una hora de inicio:',
    selectEndTime: 'Seleccione una hora de finalización:',
    selectPickupTime: 'Seleccione una hora de recogida:',
    arrivalTime: 'Seleccione la hora de llegada de su vuelo',
    departureTime: 'Selecciona la hora de salida de tu vuelo',
    mustBe: 'Debe ser al menos {pickuptimeRule} a partir de ahora',
    apply: 'Aplicar',
    useSuggested: 'Usar el tiempo sugerido',
    timeBufferError1: 'La hora seleccionada debe ser superior a {webTimeBuffer} minutos desde la hora actual.',
    timeBufferError2: 'El tiempo de vuelo {direction} no se debe establecer en el pasado',
    endDateMust: 'La fecha de finalización debe ser posterior a la fecha de inicio.',
    chooseAirline: 'Elija una aerolínea de la lista',
    chooseFlight: 'Elija un vuelo de la lista',
    thisDomestic: 'Este es un vuelo nacional',
    cantFindFlight: 'Haga clic aquí para introducir su número de vuelo',
    typeFlight: 'Escriba el número de vuelo.',
    search: 'Buscar',
    provideFlight: 'Indique su número de vuelo.',
    rideDetails: '1. Detalles de su viaje',
    selectService: '2. Seleccione un servicio',
    clickImage: 'Haz click en la imagen para una vista mas grande',
    dontWantRT: 'No quiero reservar un viaje de ida y vuelta.',
    rtDetails: '3. Detalles del viaje de ida y vuelta',
    isNotAvailable: 'no está disponible en la fecha de su viaje de regreso. Intente cambiar a otro servicio o cambie la fecha de su viaje de regreso.',
    chooseService: '4. Elija un servicio',
    returnLater: 'Regresarás más tarde?',
    bookRt: 'Reserve un viaje de regreso',
    suggestedPickupTime: 'Hora de recogida sugerida',
    firstTrip: 'para tu primer viaje',
    toMakeSurePickup: 'Para asegurarnos de que podamos recogerlo tan pronto como llegue al aeropuerto, esta es su hora de recogida sugerida:',
    toMakeSureFlight: 'Para asegurarse de no perder su vuelo, la hora de recogida sugerida es:',
    yesSuggested: 'Sí, use la hora de recogida sugerida.',
    noKeep: 'No, quiero mantener mi hora de recogida.',
    suggestedPickupTimeReturn: 'Hora de recogida sugerida para su viaje de regreso.',
    wereSorry: 'Lo sentimos, pero no tenemos viajes disponibles para la fecha y hora que seleccionaste.',
    legErrorFields: 'Etapa{leg}: Complete todos los campos obligatorios!',
    pleaseSelectService: 'Seleccione un servicio.',
    legSelectService: 'Etapa{leg}: Seleccione un servicio.',
    availableOnlyFrom: 'Disponible solo desde',
    save: 'Salvar',
    bySharingRide: 'compartiendo tu viaje.',
    ifWeFind: 'Si encontramos al menos otra persona con quien compartir su viaje, le reembolsaremos',
    atTheTime: 'en el momento en que se complete su viaje.',
    iWantTo: 'Quiero compartir mi viaje con otra persona.',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha final',
    flightArrive: 'Cuándo llegará su vuelo?',
    flightDepart: 'Cuándo saldrá su vuelo?',
    whenRide: 'Cuándo necesitas transporte?',
    flightInfo: 'Informacion de vuelo',
    pax: 'Pasajeros',
    choose: 'Escoger',
    luggage: 'Comprobar en el equipaje',
    carryOns: 'Incluye equipaje de mano',
    aptGate: 'Apartamento/Puerta #',
    optional: '(Opcional)',
    arrivalTimes: 'Los tiempos de llegada proporcionados son solo estimaciones basadas en los datos de tráfico actuales.',
    forReturnTrip: '*Para su viaje de regreso, lo recogerán el',
    scheduled: 'Programado',
    scheduledAsap: 'Programado o lo antes posible',
    selectFlightTime: 'Primero, establezca una hora de vuelo.',
    inputFlightNo: 'Seleccione o ingrese el número de vuelo.',
    bestValue: 'Mejor valor',
    fastest: 'Más rápido',
    plusApplicableFees: 'Más tarifas aplicables',
    onewayFare: 'Tarifa de ida',
    serviceAirportAvailable1: 'El servicio {service} solo está disponible en el aeropuerto de {start} a {end}.',
    serviceAirportAvailable2: 'El servicio {service} no está disponible actualmente para la recogida en el aeropuerto.',
    tryService: 'Pruebe nuestro servicio de <b>{service}</b>',
    discount: 'Descuento:',
    minutesAway: 'minuto(s) de distancia',
    pickupDate: 'Fecha de recogida:',
    dropoffTime: '*Bajar ó dejar algo: ',
    bookAdvance: 'Reservar con antelación',
    mng: 'Dar la bienvenida',
    complimentary: 'Complementario',
    viewMoreImgs: 'Ver más imágenes',
    moreInfo: 'Más información',
    hideInfo: 'Ocultar información',
    plusAppFees: 'Más tarifas aplicables',
    oneWayFare: 'Tarifa de ida',
    downstairs: 'ABAJO',
    upstairs: 'PISO DE ARRIBA',
    advantage: 'Ventaja',
    stops: 'Paradas',
    NA: 'No disponible',
    availableFrom: 'Disponible de',
    availableUntil: 'Disponible hasta',
    daysLeft: 'Días restantes',
    timeLeft: 'tiempo restante',
    tryService2: 'Prueba nuestro servicio {service}',
    wouldYouLike: 'Le gustaría probar <b>{service}</b> en su lugar?',
    yesChoose: 'Sí, elija {service}',
    pickup: 'Levantar',
    extraStop: 'Parada adicional',
    dropoff: 'Dejar',
    sharedNotAllowed: 'El servicio compartido no está permitido en la reserva con Extra Stop.',
    noService: 'No hay servicio disponible.',
    noSelectedService: 'Ningún servicio seleccionado.',
    pickupTimeMustBe: 'La hora de recogida debe ser posterior a las {time}.'
  },
  customerForm: {
    yourInfo: 'Tu información',
    emailExist: 'El correo electrónico ya existe en nuestro sistema. Si tiene una contraseña asociada con el correo electrónico proporcionado,',
    clickHere: 'haga clic aquí',
    toSignIn: 'para iniciar sesión',
    otherwisePlease: 'De lo contrario, proporcione el número de teléfono que utilizó para su reserva anterior.',
    firstName: 'Nombre de pila',
    lastName: 'Apellido',
    iHaveWheelchair: 'Tengo una silla de ruedas.',
    iHaveServiceDog: 'Tengo un perro de servicio.',
    previous: 'Previo',
    serviceSelection: 'Selección de servicios',
    paymentDetails: 'Detalles del pago',
    signIn: 'Registrarse',
    enterEmail: 'Ingrese la dirección de correo electrónico asociada con su cuenta y le enviaremos un vínculo para restablecer su contraseña.',
    sendReset: 'Enviar Restablecer contraseña',
    bookForSomeone: 'No soy el pasajero. Estoy reservando esto para otra persona.',
    paxInfo: 'Información del pasajero',
    not: 'No',
    signOut: 'Desconectar',
    alreadyHave: 'Ya tienes una cuenta?',
    signIn2: 'Iniciar sesión',
    emailUsername: 'Correo electrónico o nombre de usuario',
    forgotPass: 'Has olvidado tu contraseña?',
    corporateAccnt: 'Cuenta corporativa',
    createAccnt: 'Créame una cuenta para no tener que repetir esto la próxima vez.',
    passwordRequired: 'El campo de contraseña es obligatorio.',
    passwordNotMatch: 'Las contraseñas no coinciden.',
    confirmEmail: 'Confirmar correo electrónico'
  },
  driverReview: {
    thankYou: 'Gracias por montar con nosotros!',
    ok: 'OK',
    thankYouRating: 'Gracias por calificar este viaje!',
    feedback: 'Sus comentarios nos ayudarán a mejorar para brindarle un mejor servicio.',
    poor: 'Pobre',
    fair: 'Justo',
    average: 'Promedio',
    good: 'Bueno',
    execellent: 'Excelente!',
    rateRide: 'Califica tu viaje',
    writeComments: 'Escriba aquí sus comentarios, cumplidos o sugerencias ...'
  },
  global: {
    verify: 'Verificar',
    verified: 'Verificado',
    changePhone: 'Cambiar número de teléfono',
    textPin: 'Se envió un mensaje de texto con un PIN de 4 dígitos. Ingrese el pin en el campo a continuación.',
    pin: 'Pin',
    loading: 'Cargando',
    resendPin: 'Reenviar Pin',
    fieldRequired: 'Este campo es requerido.',
    verifyFirst: 'Primero debes verificar el móvil para continuar.',
    oops: 'UPS! Algo salió mal. Inténtalo de nuevo.',
    invalidPin: 'PIN de verificación no válido.',
    dropoffEstimate: '* El tiempo de entrega es una estimación basada en los datos de tráfico actuales.'
  },
  payment: {
    payment: 'Payment',
    cardEncrypt: 'La información de la tarjeta está encriptada, segura y protegida.',
    selectCard: 'Seleccione una tarjeta para usar',
    directBill: 'Facturación directa',
    useNew: 'Utilice una nueva tarjeta de crédito',
    selectPayment: 'Por favor seleccione un método de pago.',
    availablePayment: 'Métodos de pago disponibles',
    nameOnCard: 'Nombre en la tarjeta',
    isRequired: 'Esto es requerido.',
    cardNumber: 'Número de tarjeta',
    exp: 'Fecha de caducidad',
    securityCode: 'Código de seguridad',
    for: 'Para',
    digitCard1: 'los 3 dígitos del <i> reverso </i> de su tarjeta.',
    digitCard2: 'los 4 dígitos del <i>anverso</i> de su tarjeta.',
    billingAddr: 'Dirección de Envio',
    city: 'Ciudad',
    state: 'Expresar',
    chooseOne: 'Elige uno',
    zip: 'Código postal',
    country: 'País',
    previous: 'Previo',
    yourInfo: 'Tu información',
    validating: 'Validando...',
    reviewBook: 'Revisar y reservar',
    followFormat: 'Por favor siga el formato',
    invalidExp: 'Mes de vencimiento no válido.',
    futureDate: 'Ingrese una fecha futura.',
    fare: 'Tarifa',
    airportFee: 'Tarifa de aeropuerto:',
    fuelSurcharge: 'Recargo por combustible',
    mng: 'Meet & Greet:',
    tip: 'Consejo',
    credits: 'Créditos:',
    redeem: 'Redimir',
    total: 'Total:',
    riderFee: 'Tarifa del pasajero',
    addTip: 'Agregar sugerencia',
    changeTip: 'Cambiar consejo',
    enterTip: 'Ingrese su propina.',
    promoCode: 'Código promocional',
    leg: 'Pierna',
    custom: 'Costumbre'
  },
  rsvpDetails: {
    hideTrip: 'Ocultar resumen de viaje',
    showTrip: 'Mostrar resumen de viaje',
    tripSummary: 'Resumen de viaje',
    serviceType: 'Tipo de servicio',
    pickupType: 'Tipo de pastilla ',
    edit: 'EDITAR',
    startDate: 'Fecha de inicio',
    pickupDate: 'Fecha de recogida',
    endDate: 'Fecha final',
    driverNotes: 'Notas del conductor',
    aptGate: 'Apt/Puerta',
    flight: 'Vuelo',
    curbside: 'Acera',
    mng: 'Meet & Greet',
    complimentary: 'Complementario',
    pickup: 'Recoger',
    extraStop: 'Parada adicional',
    dropoff: 'Bajar ó dejar algo',
    inputNotes: 'Notas del controlador de entrada'
  },
  review: {
    findingRide: 'Encontrar tu viaje',
    lookNearby: 'Buscando conductores cercanos',
    busyDrivers: 'Parece que nuestros conductores están ocupados. Intentando de nuevo en',
    sendingTo: 'Enviando a',
    checking: 'Comprobación',
    sending: 'Enviando',
    yourRequest: 'tu petición',
    foundDriver: 'Te encontramos un conductor!',
    driverOTW: 'El conductor está en camino.',
    trackTrip: 'SEGUIMIENTO DE SU VIAJE',
    close: 'cerrar',
    oops: 'Huy! Algo salió mal. Por favor, inténtelo de nuevo más tarde.',
    goBack: 'Regresa',
    creditCard: 'Tarjeta de crédito',
    clickPay: 'Al hacer clic en el botón Pagar, usted acepta nuestro',
    tos: 'Términos de servicio',
    sendEmail: 'Enviaremos un correo electrónico de confirmación a',
    submittingRsvp: 'Enviar reserva',
    currentlySubmitting: 'Actualmente estamos enviando su reserva.',
    dontRefresh: 'Por favor, no abandone ni actualice esta página.',
    shouldntTake: 'Esto no debería tardar mucho.',
    successBooked: 'Ha realizado correctamente su reserva!',
    tyRsvp: 'Gracias por reservar una reserva con nosotros.',
    weSentEmail: 'Hemos enviado el correo electrónico de confirmación a',
    safelyClose: 'Ahora puede cerrar esta página de forma segura o volver a nuestro sitio web haciendo clic en',
    thisLink: 'este enlace',
    unfortunately: 'Desafortunadamente, no pudimos procesar el pago de su viaje de regreso. Puede intentarlo de nuevo y reservar su viaje de regreso por separado.',
    subscribed: 'Suscrito exitosamente a nuestra lista de correo.',
    subscribeMailing: 'Suscríbase a nuestra lista de correo para recibir ofertas y descuentos exclusivos.',
    subscribeNow: 'SUSCRÍBASE AHORA',
    reviewBook: 'Revisar y reservar',
    yourRsvp1: 'Aquí está su número de reserva',
    yourRsvp2: 'Aquí están sus números de reserva',
    pay: 'Pagar'
  },
  searchEdit: {
    editCancel: 'Editar/Cancelar su reserva',
    followInfo: 'Ingrese la siguiente información para continuar',
    isRequired: 'Esto es requerido.',
    cannotFind: 'No se puede encontrar su reserva.',
    rsvpCompleted: 'Tu reserva ya está completa.',
    rsvpCancelled: 'Tu reserva ya está cancelada.',
    cannotEdit: 'No puede editar su reserva porque su conductor ya está en camino a recogerlo.',
    onboard: 'No puede editar su reserva porque ya está a bordo.',
    rsvpDoesntExist: 'Esa reserva no existe. Verifique la información que proporcionó y vuelva a intentarlo.',
    unassign: 'Anular la asignación del controlador',
    alreadyAssigned: 'Su reserva ya está asignada a un conductor. Para editar su reserva, primero debemos desasignarla del conductor.',
    confirmUnassign: 'Desea cancelar la asignación del conductor y continuar con la edición de su reserva?',
    yes: 'Sí.',
    no: 'No, no quiero.',
    unassigning: 'Conductor no asignado',
    rsvpNumber: 'Número de reserva',
    firstName: 'Nombre de pila',
    lastName: 'Apellido'
  },
  searchTrack: {
    trackVehicle: 'Rastrea tu vehículo',
    followInfo: 'Ingrese la siguiente información para continuar',
    isRequired: 'Esto es requerido.',
    rsvpCompleted: 'Tu reserva ya está completa.',
    rsvpCancelled: 'Tu reserva ya está cancelada.',
    rsvpDoesntExist: 'Esa reserva no existe. Verifique la información que proporcionó y vuelva a intentarlo.',
    rsvpNumber: 'Número de reserva',
    firstName: 'Nombre de pila',
    lastName: 'Apellido'
  },
  rsvpEdit: {
    convertCredit: 'Tiene la opción de convertir este viaje en un Crédito de viaje.',
    convertDesc1: 'Al hacerlo, su cuenta será acreditada ',
    convertDesc2: 'que puedes usar para reservar',
    convertDesc3: 'reservaciones en cualquier momento que necesite un viaje.',
    cxlFeeWillApply: 'Se aplicarán cargos por cancelación.',
    confirmConvert: 'Le gustaría convertir esto en un crédito de viaje?',
    yes: 'Sí.',
    no: 'No, quiero cancelar este viaje.',
    confirmCancel: 'Confirmar cancelación',
    whyCancel: 'Indíquenos por qué desea cancelar esta reserva:',
    chooseOne: 'Elige uno.',
    provideReason: 'Indique el motivo de su cancelación.',
    yesCancel: 'Sí, cancelar mi reserva',
    noCancel: 'No, cambié de opinión.',
    cancelRsvp: 'Cancelación de reserva...',
    rsvp: 'Reserva',
    creditSuccess: 'Fue acreditado con éxito.',
    cancelSuccess: 'Reserva cancelada con éxito.',
    ok: 'Ok lo tengo.',
    oops: 'Huy! Algo salió mal.',
    tryAgain: 'Inténtelo de nuevo más tarde.',
    reason1: 'No estoy contento con el precio',
    reason2: 'Pude conseguir un coche de alquiler',
    reason3: 'No estoy contento con el servicio',
    reason4: 'mis planes cambiaron',
    reason5: 'Mi conductor tenía una mala actitud',
    reason6: 'Reserva duplicada',
    reason7: 'Mi conductor llegaba tarde a la camioneta',
    reason8: 'Mi conductor no llego',
    reason9: 'tomé un uber',
    reason10: 'tomé un lyft',
    reason11: 'tomé un taxi',
    reason12: 'Otro',
    cancelRsvp2: 'Estás seguro de que deseas cancelar tu reserva?',
    chargeAmount: 'Se le cobrará una tarifa de cancelación de <b>$</b><strong>{amount}</strong> cuando cancele esta reserva. <br/>Desea continuar?',
    custInfo: 'Información al cliente',
    name: 'Nombre',
    phone: 'Teléfono',
    selectStartDate: 'Seleccione una fecha de inicio:',
    selectEndDate: 'Seleccione una fecha de finalización:',
    pickupDate: 'Seleccione una fecha de recogida:',
    arrivalDate: 'Seleccione la fecha de llegada de su vuelo',
    departureDate: 'Seleccione la fecha de salida de su vuelo',
    selectStartTime: 'Seleccione una hora de inicio:',
    selectEndTime: 'Seleccione una hora de finalización:',
    arrivalTime: 'Seleccione la hora de llegada de su vuelo',
    departureTime: 'Seleccione la hora de salida de su vuelo',
    pickupTime: 'Seleccione una hora de recogida:',
    setEndTime: 'Establecer hora de finalización',
    setTime: 'Establecer hora de recogida',
    applyTime: 'Aplicar tiempo',
    buffer1: 'La hora de recogida debe ser al menos',
    buffer2: 'minutos por delante.',
    EndDateMust: 'La fecha de finalización debe ser posterior a la fecha de inicio.',
    maxDurationFor: 'La duración máxima para la reserva de chárter es {time}.',
    invalidDateRange: 'Intervalo de fechas no válido.',
    driverNotes: 'Nota al conductor',
    saveNote: 'Guardar nota',
    removeNote: 'Eliminar nota',
    emptyNotes: 'Las notas no deben estar vacías',
    chooseAirline: 'Elija una aerolínea de la lista:',
    chooseFlight: 'Elija su vuelo de la lista',
    cantFindFlight: 'No encuentro mi vuelo en la lista.',
    fieldRequired: 'Este campo es requerido.',
    domesticFlight: 'Este es un vuelo nacional',
    lookingFor: 'Buscando',
    flights: 'vuelos',
    whoBooking: 'Para quién reserva esto?',
    save: 'SALVAR',
    bookForMyself: 'Estoy reservando esto para mí.',
    nameRequired: 'Los campos Nombre y Apellido son obligatorios.',
    editingRsvp: 'Edición de reserva',
    rsvpDetails: 'Detalles de la reserva',
    pickupLoc: 'Lugar de recogida',
    addExtraStop: 'Agregar parada adicional',
    extraStop: 'Parada adicional',
    dropoffLoc: 'Punto de entrega',
    pickupTime2: 'Hora de recogida',
    UntilWhen: 'Hasta cuándo necesitas un aventón?',
    flightInfo: 'Informacion de vuelo',
    enterFlight: 'Ingrese la información de su vuelo',
    pax: 'Pasajeros',
    luggage: 'Equipaje',
    serviceType: 'Tipo de servicio',
    saveBySharing: 'Ahorre un {percent}% compartiendo su viaje.',
    ifWeFind: 'Si encontramos al menos otra persona con quien compartir su viaje, le reembolsaremos',
    atTheTime: 'en el momento en que se complete su viaje.',
    iWantToShare: 'Quiero compartir mi viaje con otra persona.',
    pickupType: 'Tipo de pastilla',
    mng: 'Meet & Greet',
    complimentary: 'Complementario',
    guestInfo: 'Informacion del Invitado',
    wheelchair: 'Silla de ruedas',
    yes2: 'Sí',
    no2: 'No',
    serviceDog: 'Perro de servicio',
    driverNote: 'Nota del conductor',
    updateRsvp: 'Actualizar mi reserva',
    cancelRsvp3: 'Cancelar mi reserva',
    returnHome: 'Regresar a la página principal',
    missedSomething: 'Parece que perdiste algo.',
    gotIt: 'OK, lo tengo.',
    suggestedPickupTime: 'Hora de recogida sugerida',
    suggesteDesc: 'Para asegurarnos de que podamos recogerlo tan pronto como llegue al aeropuerto, esta es su hora de recogida sugerida:',
    suggesteDesc2: 'Para asegurarse de no perder su vuelo, la hora de recogida sugerida es:',
    suggestedYes: 'Sí, use la hora de recogida sugerida.',
    suggestedNo: 'No, quiero mantener mi hora de recogida.',
    bookingForMyself: 'Estoy reservando esto para mi',
    bookingFor: 'Reserva para',
    addDriverNote: 'Agregue una nota para su conductor.',
    terminal: 'Terminal',
    provideFlightInfo: 'Proporcione la información de su vuelo para continuar.',
    noServiceSelected: 'Ningún servicio seleccionado.',
    serviceAccomodate1: 'El servicio que seleccionó no puede adaptarse',
    serviceAccomodate2: 'pasajeros. <br/>Por favor, seleccione un tipo de servicio diferente para continuar.',
    serviceAccomodate3: 'equipaje. <br/>Por favor, seleccione un tipo de servicio diferente para continuar.',
    pickupTimeMust: 'La hora de recogida debe adelantarse al menos {buffer} minutos.',
    pleaseSetEnd: 'Establezca su fecha de finalización.',
    typeLocation: 'Escriba su ubicación de {location}.',
    removeExtraStop: 'Eliminar parada adicional',
    extraStop2: 'parada adicional',
    pickup: 'recoger',
    dropoff: 'bajar ó dejar algo',
    pickupLocation: 'Lugar de recogida',
    dropoffLocation: 'Punto de entrega',
    sorry: 'Perdón',
    couldntLocate: 'No pudimos localizar',
    paymentInfo: 'Información del pago',
    ccUsed: 'Tarjeta de crédito utilizada:',
    paidThru: 'Pagado por otros medios.',
    fare: 'Tarifa:',
    airportFee: 'Tarifa de aeropuerto:',
    fuelSurcharge: 'Recargo por combustible:',
    tip: 'Consejo:',
    creditUsed: 'Créditos utilizados:',
    total: 'Total:',
    travelInsu: 'Seguro de viaje',
    startDate: 'Fecha de inicio',
    pickupDate2: 'Fecha de recogida',
    availableOnlyFrom: 'Disponible solo desde ',
    chooseService: 'Elija un servicio:',
    doYouWant: 'Quieres compartir tu viaje con alguien más?',
    yesIWantToShare: 'Sí, quiero compartir mi viaje con otra persona.',
    noThanks: 'No, gracias.',
    NA: 'No disponible',
    availableFrom: 'Disponible de',
    availableUntil: 'Disponible hasta',
    tryOur: 'Prueba nuestro',
    service: 'Servicio',
    serviceAvailable: 'El servicio solo está disponible en el aeropuerto desde',
    to: 'a',
    serviceAirportPickup: 'El servicio actualmente no está disponible para la recogida en el aeropuerto.',
    wouldYouLike: 'Te gustaría intentarlo',
    instead: 'en lugar de?',
    yes3: 'Si, elige',
    changePickupTime: 'Cambiaré la hora de recogida',
    confirmUpdate: 'Confirmar actualización',
    updateRsvp2: 'Estás seguro de que quieres actualizar tu reserva?',
    yesUpdate: 'Actualizar mi reserva',
    updatingRsvpp: 'Actualizando reserva...',
    successUpdate: 'Reserva actualizada con éxito.',
    okUpdate: 'Ok lo tengo.',
    failUpdate: 'No se pudo actualizar su reserva. No podemos procesar su información de pago.',
    dueCharged: 'Debido a los cambios que realizó en su reserva, se le cobrará un adicional',
    yourCard: 'a su tarjeta de crédito.',
    dueRefund: 'Debido a los cambios que realizó en su reserva, se le reembolsará',
    typeNote: 'Escriba una nota aquí',
    search: 'Buscar...',
    typeFlight: 'Escriba su número de vuelo.',
    firstName: 'Nombre de pila',
    lastName: 'Apellido',
    phoneNumber: 'Número de teléfono',
    forRsvpInfo: 'Para actualizaciones de información de reserva, cancele esta reserva y vuelva a reservar.',
    riderFee: 'Tarifa del pasajero'
  },
  rsvpTrack: {
    rsvpDetails: 'detalles de la reserva',
    pickupLoc: 'Lugar de recogida',
    extraStop: 'Parada adicional',
    dropoffLock: 'Punto de entrega',
    pickupTime: 'Hora de recogida',
    endTime: 'Hora de finalización',
    flightInfo: 'Informacion de vuelo',
    noFlightInfo: 'Sin información de vuelo',
    pax: 'Pasajeros',
    luggage: 'Equipaje',
    serviceType: 'Tipo de servicio',
    pickupType: 'Tipo de pastilla',
    mng: 'Meet & Greet',
    guestInfo: 'Informacion del Invitado',
    wheelchair: 'Silla de ruedas',
    yes: 'Sí',
    no: 'No',
    serviceDog: 'Perro de servicio',
    driverNote: 'Nota del conductor',
    bookForMyself: 'Estoy reservando esto para mi',
    bookFor: 'Reserva para',
    noDriverNotes: 'No hay notas para el conductor.',
    terminal: 'Terminal',
    eta: 'Tiempo estimado de llegada:',
    yourDriver: 'Tu conductor',
    noDriverYet: 'Parece que todavía no tienes un controlador.',
    driverCheckAgain: 'Vuelva a verificarlo una (1) hora antes de la hora de recogida.',
    phone: 'Número de teléfono:',
    email: 'Email Address:',
    driverLicense: 'Licencia de conducir No.:',
    bestExp: 'Para obtener la mejor experiencia, descargue la aplicación móvil {brandName} usando los botones a continuación.',
    appStore: 'Tienda de aplicaciones',
    playStore: 'Tienda de juegos',
    trackRsvp: 'Reserva de seguimiento',
    returnHome: 'Regresar a la página principal'
  },
  events: {
    sentPassword: 'Le enviamos un correo electrónico de recuperación de contraseña',
    invalidPromo: 'Código de promoción no válido.',
    successRedeem: 'Canjeado con éxito',
    invalidDiscount: 'El código que ingresaste no es válido.',
    expiredDiscount: 'Código caducado: El código que ingresó ha caducado.'
  },
  progressbar: {
    chooseRide: 'Elija su viaje',
    enterDetails: 'Introduce tus detalles',
    paymentDetails: 'Detalles del pago',
    reviewBook: 'Revisar y reservar'
  },
  backend: {
    "There is no service available": "No hay ningún servicio disponible.",
    "Out of coverage area": "Fuera del área de cobertura",
    "Trip is currently under auto-dispatch": "El viaje se encuentra actualmente en envío automático.",
    "Invalid token": "Simbolo no valido.",
    "Authentication error": "Error de autenticación.",
    "Corporate profile is not associated with a customer account": "El perfil corporativo no está asociado a una cuenta de cliente",
    "Authentication error. Invalid token": "Error de autenticación. Simbolo no valido.",
    "Authentication error. Account may have been logged in on another device": "Error de autenticación. Es posible que se haya iniciado sesión en la cuenta en otro dispositivo.",
    "Account is disabled": "Cuenta deshabilitada",
    "Cannot determine pricing": "No se puede determinar el precio",
    "This geofence does not support ASAP trips": "Esta geovalla no admite viajes ASAP",
    "Cons Auth": "Contras Auth",
    "Consumer account is disabled": "La cuenta del consumidor está inhabilitada",
    "Unable to use the credit card selected": "No se puede utilizar la tarjeta de crédito seleccionada",
    "No payment options selected": "No se seleccionaron opciones de pago",
    "Please enter a valid tip": "Ingrese una propina válida",
    "Unable to fetch pricing": "No se pudo recuperar el precio",
    "This geofence does not support future reservations": "Esta geovalla no admite reservas futuras",
    "Invalid payment calculation": "Cálculo de pago no válido",
    "Invalid pickup time": "Hora de recogida no válida",
    "Invalid payment calculation!": "¡Cálculo de pago no válido!",
    "Invalid payment calculation!!": "¡¡Cálculo de pago no válido !!",
    "Invalid reservation": "Reserva inválida",
    "Unable to edit reservation of another brand": "No se puede editar la reserva de otra marca",
    "ERR_EDIT_RESTRICTED', 'Reservation cannot be edited anymore": "ERR_EDIT_RESTRICTED ',' La reserva ya no se puede editar",
    "Cannot display brand": "No se puede mostrar la marca",
    "Unknown trx ID": "ID de trx desconocido",
    "Cant get consumer login": "No puedo obtener acceso de consumidor",
    "Cant get consumer connection": "No puedo conectarme con el consumidor",
    "Brand is required": "Se requiere marca",
    "No phone number": "Sin numero de telefono",
    "Error finding corporate token": "Error al encontrar el token corporativo",
    "Invalid corporate token": "Token corporativo no válido",
    "Error finding corporate profile": "Error al encontrar el perfil corporativo",
    "Corporate profile not found": "Perfil corporativo no encontrado",
    "Error finding corporate device": "Error al encontrar el dispositivo corporativo",
    "Corporate device not found": "Dispositivo corporativo no encontrado",
    "Dispatch view requires [since]": "La vista de envío requiere [desde]",
    "Dispatch view requires [until]": "La vista de envío requiere [hasta]",
    "Date range is required to filter": "Se requiere un rango de fechas para filtrar",
    "Trip requires wheelchair lift": "El viaje requiere un elevador de silla de ruedas.",
    "Trip requires service dog": "El viaje requiere un perro de servicio.",
    "Trip requires military clearance": "El viaje requiere autorización militar.",
    "Unable to mark as arrived, current location is not yet near the pickup": "No se puede marcar como llegado, la ubicación actual aún no está cerca de la recogida",
    "ERR_RESTRICTED_GEOFENCE', 'You cannot view available reservations on a restricted area": "ERR_RESTRICTED_GEOFENCE ',' No puedes ver las reservas disponibles en un área restringida",
    "Unable to mark as complete, current location is not yet near the dropoff": "No se puede marcar como completo, la ubicación actual aún no está cerca del punto de destino",
    "cannot get staging lot queue": "no se puede obtener la cola del lote de preparación",
    "cannot find drivers": "no puedo encontrar controladores",
    "cannot find staging lots": "no puedo encontrar lotes de preparación",
    "Cannot find driver": "No puedo encontrar el controlador",
    "Cannot find driver's services": "No se pueden encontrar los servicios del controlador",
    "Only transport drivers are allowed at the moment": "Solo los conductores de transporte están permitidos en este momento.",
    "First Name is required": "Se requiere el primer nombre",
    "Last Name is required": "Se requiere apellido",
    "Password is required": "se requiere contraseña",
    "Mobile Phone is required": "Se requiere teléfono móvil",
    "Requires lat": "Requiere lat",
    "Requires lng": "Requiere lng",
    "Requires radius": "Requiere radio",
    "Package has already been accepted by a driver": "El paquete ya ha sido aceptado por un conductor.",
    "Package is currently under auto-package": "El paquete está actualmente en paquete automático.",
    "Package does not contain any reservations": "El paquete no contiene reservas",
    "cannot find provider": "no puedo encontrar proveedor",
    "Cannot find driver's vehicle": "No se puede encontrar el vehículo del conductor",
    "cannot get provider's enabled services": "no puede obtener los servicios habilitados del proveedor",
    "Driver cannot accept shared packages": "El conductor no puede aceptar paquetes compartidos",
    "Vehicle is not equipped with wheelchair lift": "El vehículo no está equipado con elevador de sillas de ruedas",
    "Vehicle cannot accommodate a service dog": "El vehículo no puede acomodar a un perro de servicio",
    "Vehicle cannot accommodate a military clearance": "El vehículo no puede acomodar una autorización militar",
    "Package geofence does not support TNC": "El paquete de geovalla no es compatible con TNC",
    "Package geofence does not support TCP": "El paquete de geovalla no es compatible con TCP",
    "Driver does not have availability at the reservation's time": "El conductor no tiene disponibilidad al momento de la reserva.",
    "Trip is not available anymore": "Trip ya no está disponible.",
    "Driver cannot accept this service type": "El conductor no puede aceptar este tipo de servicio",
    "gg": "dias",
    "Driver is not on duty": "El conductor no está de servicio",
    "Cannot get tracks list": "No se puede obtener la lista de pistas",
    "Cannot get geofence list": "No se puede obtener la lista de geovallas",
    "Invalid reset password key": "Clave de contraseña de restablecimiento no válida",
    "Unable to find directions": "No puedo encontrar direcciones",
    "Unable to find directions for the specified pickup and dropoff": "No se pueden encontrar direcciones para la recogida y devolución especificadas",
    "E_CANNOT_LOGIN": "E_CANNOT_LOGIN",
    "E_EMAIL_EXISTS": "E_EMAIL_EXISTS",
    "User not found": "Usuario no encontrado",
    "Parameters [contactID] must be an array": "Los parámetros [contactID] deben ser una matriz",
    "Cannot find phone numbers": "No puedo encontrar los números de teléfono",
    "package items required": "elementos del paquete requeridos",
    "Part of the packages to be merged are already assigned to a driver": "Parte de los paquetes que se fusionarán ya están asignados a un controlador",
    "Part of the reservations are already assigned to a driver": "Parte de las reservas ya están asignadas a un conductor.",
    "Phone number already exists": "El número de teléfono ya existe",
    "Unable to find pickup geofences": "No se pueden encontrar geocercas de recogida",
    "Unable to find dropoff geofences": "No se pueden encontrar geocercas de bajada",
    "Services unavailable": "Servicios no disponibles",
    "Tip has already been given beforehand": "La propina ya se ha dado de antemano",
    "Consumer card not available": "Tarjeta de consumidor no disponible",
    "rsvp not found": "rsvp no encontrado",
    "No card that can be charged using stripe": "Ninguna tarjeta que se pueda cargar con stripe",
    "Credit card cannot be found anymore": "Ya no se puede encontrar la tarjeta de crédito",
    "rsvpId is required": "Se requiere rsvpId.",
    "Schedule not found": "Horario no encontrado",
    "Schedule items not found": "Programar elementos no encontrados",
    "Schedule assigned to other driver": "Horario asignado a otro conductor",
    "Schedule is not available anymore": "El horario ya no está disponible",
    "Invalid fare matrix. Please contact administrator": "Matriz de tarifas no válida. Comuníquese con el administrador.",
    "Unable to get vehicle for provider": "No se pudo conseguir el vehículo para el proveedor",
    "Driver is not TNC": "El conductor no es TNC",
    "requires ID": "requiere identificación",
    "1.0 Cannot updated customer profile": "1.0 No se puede actualizar el perfil del cliente",
    "1.0 Cannot create stripe profile": "1.0 No se puede crear un perfil de rayas",
    "Forbidden": "Prohibido",
    "No drivers to send": "No hay controladores para enviar",
    "Invalid password recovery token": "Token de recuperación de contraseña no válido",
    "Cannot find admins": "No se pueden encontrar administradores",
    "Unable to find filter": "No se pudo encontrar el filtro",
    "Please leave a note when marking an RSVP as complete": "Deje una nota cuando marque una confirmación de asistencia como completa",
    "Notes are required when cancelling reservation": "Se requieren notas al cancelar la reserva",
    "Reservation not found": "Reserva no encontrada",
    "Unknown charge identifier": "Identificador de cargo desconocido",
    "Invalid charge amount": "Importe de cargo no válido",
    "403 Forbidden": "403 Prohibido",
    "Unable to get autodispatch triggers": "No se pueden obtener los activadores de autodispatch",
    "Unable to get autodispatch logs": "No se pueden obtener los registros de autodispatch",
    "Unable to break a package that is already assigned to a driver": "No se puede romper un paquete que ya está asignado a un controlador",
    "Driver not subscribed to notifications": "Conductor no suscrito a notificaciones",
    "Corporate Username already exists": "El nombre de usuario corporativo ya existe",
    "Unable to create profile info": "No se pudo crear la información del perfil",
    "Username already exists": "nombre de usuario ya existe",
    "Invalid corporate profile": "Perfil corporativo no válido",
    "Corporate profile is not linked to a customer account": "El perfil corporativo no está vinculado a una cuenta de cliente",
    "Invoice not found": "Factura no encontrada",
    "Unable to check for invoice date conflicts": "No se puede verificar si hay conflictos con la fecha de la factura",
    "Failed to create invoice": "No se pudo crear la factura",
    "Cannot refresh invoice information": "No se puede actualizar la información de la factura",
    "Cannot find ads": "No puedo encontrar anuncios",
    "No currently running ad": "No hay ningún anuncio que se esté publicando actualmente",
    "Username is required": "Se requiere nombre de usuario",
    "Token is required": "Se requiere token",
    "Error trying to find corporate account": "Error al intentar encontrar la cuenta corporativa",
    "Invalid corporate account": "Cuenta corporativa no válida",
    "Corporate account is disabled": "La cuenta corporativa está inhabilitada",
    "Unable to get nearby drivers": "No se pueden conseguir conductores cercanos",
    "flight not found": "vuelo no encontrado",
    "[services] is required": "[servicios] es obligatorio",
    "[services] needs to be an array": "[servicios] debe ser una matriz",
    "[props] is required": "[accesorios] es obligatorio",
    "no consumer to notify": "ningún consumidor para notificar",
    "invalid consumer id": "ID de consumidor no válido",
    "not found": "extraviado",
    "Unable to get credit card list": "No se puede obtener la lista de tarjetas de crédito",
    "Catd not found": "Catd no encontrado",
    "Action unauthorized for non-drivers": "Acción no autorizada para no conductores",
    "Your driver account is not active. Action is restricted": "Su cuenta de conductor no está activa. La acción está restringida.",
    "The reservation has already been canceled": "La reserva ya ha sido cancelada",
    "Please enable your location tracking to be able to start trip": "Habilite el seguimiento de su ubicación para poder iniciar el viaje",
    "Unable to get your location": "No se puede obtener tu ubicación.",
    "You can only start this trip once you are in the staging area": "Solo puede comenzar este viaje una vez que esté en el área de preparación",
    "Reservation is not yet completed": "La reserva aún no está completa",
    "Invalid package": "Paquete inválido",
    "Unauthorized": "No autorizado",
    "Shift not created": "Turno no creado",
    "Unable to find shift": "Incapaz de encontrar el turno",
    "Shift not found": "Cambio no encontrado",
    "Unable to find sector": "No se puede encontrar el sector",
    "Sector not found": "Sector no encontrado",
    "Unable to find subsector": "No se pudo encontrar el subsector",
    "Subsector not found": "Subsector no encontrado",
    "Unable to find phone number for this provider": "No se puede encontrar el número de teléfono de este proveedor.",
    "Unable to find address for this provider": "No se puede encontrar la dirección de este proveedor",
    "This provider has no account yet": "Este proveedor aún no tiene una cuenta.",
    "Cannot find external account for this provider": "No se puede encontrar una cuenta externa para este proveedor.",
    "No ongoing reservation": "Sin reserva en curso",
    "[geofenceId] needs to be passed as an array": "[geofenceId] debe pasarse como una matriz",
    "Unable to find airport association": "No se pudo encontrar la asociación del aeropuerto",
    "A KML File is required to activate this geofence": "Se requiere un archivo KML para activar esta geovalla",
    "Cannot find subgeofences": "No se pueden encontrar subgeofences",
    "No vehicles found for driver": "No se encontraron vehículos para el conductor",
    "1.1 Cannot update customer profile": "1.1 No se puede actualizar el perfil del cliente",
    "1.1 Cannot create stripe profile": "1.1 No se puede crear un perfil de banda",
    "Unknown reservation": "Reserva desconocida",
    "Reservation is not scheduled to this time": "La reserva no está programada para esta hora.",
    "Forbidden to view this reservation": "Prohibido ver esta reserva",
    "Reservation is not accepted by any provider yet": "Ningún proveedor aún acepta reservas",
    "There is another reservation scheduled now": "Hay otra reserva programada ahora",
    "A credit card is required": "Se requiere una tarjeta de crédito",
    "Unable to find list of transactions": "No se puede encontrar la lista de transacciones.",
    "This reservation is not paid through other means": "Esta reserva no se paga por otros medios",
    "Card not found": "Tarjeta no encontrada",
    "Unable to charge the card": "No se puede cargar la tarjeta",
    "Unable to charge the card. No result": "No se puede cargar la tarjeta. Sin resultados.",
    "Unable to charge the card. No ID": "No se puede cargar la tarjeta. Sin identificación.",
    "Notification token is required": "Se requiere el token de notificación",
    "Requires since parameter": "Requiere desde parámetro",
    "Requires until parameter": "Requiere hasta parámetro",
    "no location": "sin ubicación",
    "Not allowed": "No permitido",
    "Reservation is not yet complete": "La reserva aún no está completa",
    "Reservation has already been reviewed": "La reserva ya ha sido revisada",
    "Sector not created": "Sector no creado",
    "Subsector not created": "Subsector no creado",
    "[driverId] is required": "[driverId] es obligatorio",
    "Parameter [chargeFees] must be true or false only": "El parámetro [chargeFees] debe ser verdadero o falso únicamente",
    "Parameter [cancel] must be true or false only": "El parámetro [cancelar] debe ser verdadero o falso únicamente",
    "Transaction has already been refunded": "La transacción ya ha sido reembolsada",
    "Unable to deduct credits": "No se pueden deducir los créditos",
    "Parameter [amount] is required": "El parámetro [monto] es obligatorio",
    "Unable to fetch import record": "No se pudo recuperar el registro de importación",
    "Unable to determine pickup geofence": "No se puede determinar la geovalla de recogida",
    "Pickup location out of coverage area": "Lugar de recogida fuera del área de cobertura",
    "Unable to determine dropoff geofence": "No se pudo determinar la geovalla de descenso",
    "Dropoff location out of coverage area": "Ubicación de entrega fuera del área de cobertura",
    "Attempting to { list: [], paging: {} } a non-array": "Intentando {lista: [], paginación: {}} una no matriz",
    "Attempting to { list: [] } a non-array": "Intentando {lista: []} un no-arreglo",
    "Bid has already been cancelled": "La oferta ya ha sido cancelada",
    "Bid has already been accepted": "La oferta ya ha sido aceptada",
    "Unable to fetch drivers without business": "No se pueden buscar conductores sin negocio",
    "Unable to fetch driver list without business": "No se puede recuperar la lista de conductores sin negocio",
    "Brand is required for quotation": "Se requiere marca para cotización",
    "Pickup is required for quotation": "Se requiere recogida para cotización",
    "Dropoff is required for quotation": "Se requiere devolución para cotización",
    "No services available": "No hay servicios disponibles",
    "Unable to fetch pickup types": "No se pueden recuperar los tipos de recogida",
    "Unable to fetch services": "No se pueden recuperar los servicios",
    "Unknown payout status": "Estado de pago desconocido",
    "Destination account not found 1": "Cuenta de destino no encontrada 1",
    "Unknown payout status 2": "Estado de pago desconocido 2",
    "Unknown payout status 3": "Estado de pago desconocido 3",
    "Expired password recovery key": "Clave de recuperación de contraseña caducada",
    "Charter service is not available for this area": "El servicio de charter no está disponible para esta área",
    'Invalid promo code': 'Código de promoción no válido.',
    'This promo code is only valid for new users': 'Este código de promoción solo es válido para nuevos usuarios',
    'Promo already expired': 'Promoción ya caducada',
    "Payment method for this reservation is no longer available": "El método de pago para esta reserva ya no está disponible.",
    "Phone already in use. Please log in or reset your password": "Teléfono ya en uso. Por favor inicie sesión o restablezca su contraseña."
  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js